<template>
  <div class="graphicnavigation">
    <div
      :style="{
        background: datas.backColor,
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
    >
      <section v-if="datas.styleType < 5" class="nav_con">
        <div
          v-for="index in datas.styleType + 1"
          :key="index"
          :class="['nav_item', 'nav_item_' + datas.styleType]"
          :style="{
            width: 100 / (datas.styleType + 1) + '%',
          }"
          @click="handleClickImg(datas.imageList[index - 1])"
        >
          <img
            draggable="false"
            :src="
              datas.imageList[index - 1] && datas.imageList[index - 1].imgUrl
                ? datas.imageList[index - 1].imgUrl
                : defaultImg
            "
            alt=""
          />
          <div
            :style="{
              'font-size': datas.wordSize + 'px',
              'font-weight': datas.isBold ? 'bold' : 'normal',
              'font-style': datas.isTilt ? 'italic' : 'normal',
              'text-decoration': datas.isUnderLine ? 'underline' : 'none',
              color: datas.wordColor,
            }"
          >
            {{
              datas.imageList[index - 1] ? datas.imageList[index - 1].title : ""
            }}
          </div>
        </div>
      </section>
      <!-- 导航列表 -->
      <section v-else class="nav_list_con">
        <!-- 导航 -->
        <template v-if="datas.imageList.length == 0">
          <div v-for="index in 2" :key="index" class="nav_list_item">
            <div class="img_con">
              <div v-if="datas.styleType == 6">
                <img draggable="false" :src="defaultImg" alt="" />
              </div>
              <div
                :style="{
                  'font-size': datas.wordSize + 'px',
                  'font-weight': datas.isBold ? 'bold' : 'normal',
                  'font-style': datas.isTilt ? 'italic' : 'normal',
                  'text-decoration': datas.isUnderLine ? 'underline' : 'none',
                  color: datas.wordColor,
                }"
              ></div>
            </div>
            <div
              class="arrow_con"
              :style="{
                color: datas.arrowBgColor,
              }"
            >
              <i class="iconfont icon-xiangyou" />
            </div>
          </div>
        </template>
        <template v-else>
          <!-- 导航 -->
          <div
            v-for="(item, index) in datas.imageList"
            :key="index"
            class="nav_list_item"
            @click="handleClickImg(item)"
          >
            <div class="img_con">
              <div v-if="datas.styleType == 6">
                <img
                  draggable="false"
                  :src="item.imgUrl ? item.imgUrl : defaultImg"
                  alt=""
                />
              </div>
              <div
                :style="{
                  'font-size': datas.wordSize + 'px',
                  'font-weight': datas.isBold ? 'bold' : 'normal',
                  'font-style': datas.isTilt ? 'italic' : 'normal',
                  'text-decoration': datas.isUnderLine ? 'underline' : 'none',
                  color: datas.wordColor,
                }"
              >
                {{ item.title }}
              </div>
            </div>
            <div
              class="arrow_con"
              :style="{
                color: datas.arrowBgColor,
              }"
            >
              <i class="iconfont icon-xiangyou" />
            </div>
          </div>
        </template>
      </section>
    </div>
    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
import { handleScanCode } from "@/utils";
export default {
  name: "Graphicnavigation",
  props: {
    datas: Object,
  },
  data() {
    return {
      defaultImg: require("@/assets/images/defaultPic2.png"),
    };
  },
  created() {
    console.log(this.datas, "--------graphicnavigation");
  },
  methods: {
    handleClickImg(item) {
      if (!item) return;
      if (item.linkType == "scanCode") {
        // 调起微信扫码，扫码取号并自动跳转到扫码信息页面
        handleScanCode();
      } else if (item.linkUrl) {
        window.location.href = item.linkUrl;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.graphicnavigation {
  position: relative;
  .nav_con {
    display: flex;
    .nav_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        margin-bottom: 15px;
      }
      &.nav_item_1 {
        img {
          width: 86px;
          height: 86px;
        }
      }
      &.nav_item_2 {
        img {
          width: 86px;
          height: 86px;
        }
      }
      &.nav_item_3 {
        img {
          width: 60px;
          height: 60px;
        }
      }
      &.nav_item_4 {
        img {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
  .nav_list_con {
    .nav_list_item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 15px;
      margin-bottom: 15px;
      .img_con {
        display: flex;
        align-items: center;
        img {
          width: 96px;
          height: 96px;
          margin-right: 30px;
          vertical-align: middle;
        }
      }
      .arrow_con {
        .iconfont {
          font-size: 24px;
        }
      }
    }
  }
}
</style>
